import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import { locale } from './i18n'

import '@pinchcrew/ui/styles'
import './styles.css'

document.documentElement.lang = locale.value

const pinia = createPinia()
const app = createApp(App).use(pinia)

/**
 * Restore a stored session BEFORE installing the router.
 *
 * `app.use(router)` kicks off the first navigation synchronously, so the
 * guard runs against whatever state exists at that moment. Restoring
 * afterwards is too late: the user is already at /login, and their valid
 * token looks like no session at all.
 */
useAuthStore(pinia)
  .restore()
  .finally(() => {
    app.use(router)
    app.mount('#app')
  })
